import { useEffect, useRef, useState } from 'react';

export default function useMenuSuspenso() {
    const [aberto, setAberto] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        const fecharAoClicarFora = (evento) => {
            if (wrapperRef.current && !wrapperRef.current.contains(evento.target)) setAberto(false);
        };
        document.addEventListener('mousedown', fecharAoClicarFora);
        return () => document.removeEventListener('mousedown', fecharAoClicarFora);
    }, []);

    return { aberto, setAberto, wrapperRef };
}
